import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        message: 'loading',
        alert: {
            alert: false,
            closeable: true,
            color: 'green'
        },
        ticket: {
            ticket: false
        },
        timeout: {
            timeout: false
        },
        high_contrast: false
    },
    mutations: {
        showLoading(state) {
            state.loading = true;
        },
        hideLoading(state) {
            state.loading = false;
        }
    }
})